var map = {
	"./PROD1114.jpeg": 3459,
	"./PROD1115.jpeg": 6780,
	"./PROD1116.jpeg": 3309,
	"./PROD1211.jpeg": 9465,
	"./default-product.jpeg": 1056,
	"./image1.jpeg": 9809,
	"./image2.jpeg": 8160,
	"./image3.jpeg": 2871,
	"./image4.jpeg": 1214,
	"./image5.jpeg": 3173,
	"./phone-background.jpeg": 682
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4942;